import { render, staticRenderFns } from "./SortHeader.vue?vue&type=template&id=a79fc550&scoped=true"
import script from "./SortHeader.vue?vue&type=script&lang=ts"
export * from "./SortHeader.vue?vue&type=script&lang=ts"
import style0 from "./SortHeader.vue?vue&type=style&index=0&id=a79fc550&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79fc550",
  null
  
)

export default component.exports